const formatter = Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
})

export const currencyFormatter = (value: number): string => {
  return formatter.format(value)
}

export const currencyFormatterNoTrailingZeros = (value: number): string => {
  return currencyFormatter(value).replace(/\.0+$/, '')
}

export const currencyFormatterNoDemcimal = (value: number): string => {
  return currencyFormatter(value).split('.')[0]
}
